module.exports = __webpack_public_path__ + "static/mini-6d4b114bfe5d74bd2c978f1c26fa7d47.png";